'use client';

import React__default from 'react';
import { PanelCss } from '../styles/index.css.js';

function Panel(_a) {
    var children = _a.children;
    return React__default.createElement(PanelCss, null, children);
}

export { Panel as default };
//# sourceMappingURL=Panel.js.map
